// src/app/interceptors/api-prefix.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Capacitor } from '@capacitor/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class ApiPrefixInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only do this on native (iOS/Android). On web, keep relative /api calls.
    const isNative = Capacitor.isNativePlatform();

    if (!isNative) {
      return next.handle(req);
    }

    // Don’t touch already-absolute URLs (http/https)
    const isAbsolute = /^https?:\/\//i.test(req.url);

    // Only rewrite calls that start with /api (or api/)
    const isApiCall =
      req.url.startsWith('/api/') || req.url === '/api' ||
      req.url.startsWith('api/');

    if (isApiCall && !isAbsolute) {
      const url = req.url.startsWith('/') ? req.url : `/${req.url}`;
      const apiOrigin = environment.apiOrigin.replace(/\/api\/?$/, '');
      const rewritten = req.clone({ url: `${apiOrigin}${url}` });
      return next.handle(rewritten);
    }

    return next.handle(req);
  }
}
